import styled from 'styled-components';

export const StyledLink = styled.a.attrs(props => ({
  as: props.as || 'a'
}))`
    border: none;
    background: none;
    padding: 0;
    font-family: ${props => props.theme.lightFont};
    font-size: 20px;
    font-weight: 300;
    line-height: 20.09px;
    color: ${props => props.theme.textColor};
    text-decoration: none;
    cursor: pointer;
`;